<template>

  <Toast :group="page.name" position="bottom-center" />
  <Loader v-if="loader" />
 
  <div class="page">
      <Badge value="regolari" class="mr-2 bg-green-100 text-500"></Badge>
      <Badge value="saldoUltimoMese 0, saldo &gt; 0 e fattura/preavviso non scaduti" class="mr-2 bg-blue-100 text-500"></Badge>
      <Badge value="pagato tutto tranne ultima fattura non scaduta o preavviso non partito" class="mr-2 bg-orange-100 text-700"></Badge>
      <Badge value="volturato di recente" class="mr-2 bg-purple-100 text-700"></Badge>
    </div>
    <div class="my-2 flex flex-wrap align-items-center gap-2">
      <label for="mese-preavviso" class="font-medium mr-2">Ordina per mese invio preavviso:</label>
      <Dropdown
        id="mese-preavviso"
        v-model="mesePreavvisoSelezionato"
        :options="opzioniMesi"
        optionLabel="label"
        optionValue="value"
        placeholder="Tutti i mesi"
        showClear
        class="w-full md:w-14rem"
      />
    <DataTable :value="itemsOrdinati" v-model:selection="selectedItems" :filters="filters" :rowClass="rowClass" dataKey="id" responsiveLayout="scroll">
        <Column selectionMode="multiple" style="width: 3rem" :exportable="false"></Column>
        <Column field="code" header="Fornitura" :sortable="true"></Column>
        <Column field="data_inizio" header="Data Inizio" :sortable="true" style="min-width:120px">
          <template #body="{data}">
            {{formatDate(data.data_inizio)}}     
          </template>
        </Column>
        <Column field="data_fine" header="Data fine" :sortable="true" style="min-width:120px">
          <template #body="{data}">
            {{formatDate(data.data_fine)}}     
          </template>
        </Column>
        <Column field="data_invio_preavviso" header="Data Invio Preavviso" :sortable="true" style="min-width:120px">
          <template #body="{data}">
            <p v-if="data.data_invio_preavviso">{{ formatDate(data.data_invio_preavviso) }}</p>
            <p v-else>-</p>
          </template>
        </Column>
        <Column field="data_scadenza_preavviso" header="Scadenza preavviso" :sortable="true" style="min-width:120px">
          <template #body="{data}">
            <p v-if="data.data_scadenza_preavviso">{{ formatDate(data.data_scadenza_preavviso) }}</p>
            <p v-else>-</p>
          </template>
        </Column>
        <Column field="data_scadenza_fattura" header="Scadenza fattura" :sortable="true" style="min-width:120px">
          <template #body="{data}">
            <p v-if="data.data_scadenza_fattura">{{ formatDate(data.data_scadenza_fattura) }}</p>
            <p v-else>-</p>
          </template>
        </Column>
        <Column field="cliente" header="Cliente" :sortable="true"></Column>
        <Column field="data_stato_interno" header="Inviato a reparto pratiche" :sortable="true">
          <template #body="{data}">
            <p v-if="data.data_stato_interno">{{formatDate(data.data_stato_interno, 'dt')}}</p>
            <p v-else>No</p>  
          </template>
        </Column>
        <Column field="agente" header="Agente" :sortable="true"></Column>
        <Column field="rappresentante" header="Rappresentante" :sortable="true"></Column>
        <Column field="saldo" header="Saldo">
          <template #body="{data, field}">
            {{data[field].toFixed(2)}} 
          </template>
        </Column>
        <Column field="saldoUltimoMese" header="Saldo mese precedente">
          <template #body="{data, field}">
            {{data[field].toFixed(2)}} 
          </template>
        </Column>
        <Column field="totaleContabili" header="Totale contabili">
          <template #body="{data, field}">
            {{data[field].toFixed(2)}} 
          </template>
        </Column>
        <Column field="stato_tutela" header="Tutela Richiesta" :sortable="true">
          <template #body="{data}">
            {{ data.stato_tutela || '' }}
          </template>
        </Column>
    </DataTable>
  </div>

      
  <div class="wrap-footer-main-dialog">
    <div class="footer-main-dialog">
      <Button 
          label="Chiudi" 
          icon="pi pi-times"
          iconPos="right" 
          class="p-button-secondary mr-3"
          @click="onCancelButton($event)" 
        />
        <Button 
          :label="`Aggiungi ${selectedItems.length} ${type_fornitura} in preview`" 
          :disabled="selectedItems.length == 0"
          icon="pi pi-check"
          iconPos="right" 
          class="mr-3"
          @click="onOkButton($event)" 
        />
    </div>
  </div>

</template>

<script>

import { ref, computed, getCurrentInstance, onMounted} from 'vue';
import Service from '@/services/ask-operation/operation-service'
// import UtilityService from '@/services/ask-management/utility-service'
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'
// import { useToast } from "primevue/usetoast";

export default {
  props: {
   data: {
      type: Object,
      required: true
    }
  },
  components: {
    Loader
  },
    
  setup(props) {

    const filters = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
    });
    const page = { name: 'pods-sospensioni-saldate'}
    const loader = ref(false)
    // const toast = useToast();
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const formatDate = self.appContext.config.globalProperties.$formatDate
    const service = new Service(self.$http, self.$eventBus)
    const items = ref()
    const selectedItems = ref([]);
    const type_fornitura = ref(props.data.type)
    const validationErrors = ref({})
    const submitted = ref(false);
    const mesePreavvisoSelezionato = ref(null);

    const mesiLabels = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
    const opzioniMesi = (() => {
      const opts = [{ label: 'Tutti i mesi', value: null }];
      const now = new Date();
      for (let i = 0; i < 24; i++) {
        const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
        opts.push({
          label: `${mesiLabels[d.getMonth()]} ${d.getFullYear()}`,
          value: { year: d.getFullYear(), month: d.getMonth() + 1 }
        });
      }
      return opts;
    })();

    const isDataInMese = (dataStr, year, month) => {
      if (!dataStr) return false;
      const d = new Date(dataStr);
      return !isNaN(d.getTime()) && d.getFullYear() === year && d.getMonth() + 1 === month;
    };

    const itemsOrdinati = computed(() => {
      const list = items.value || [];
      const sel = mesePreavvisoSelezionato.value;
      if (!sel || !sel.year || !sel.month) return list;
      return [...list].sort((a, b) => {
        const aInMese = isDataInMese(a.data_invio_preavviso, sel.year, sel.month) ? 0 : 1;
        const bInMese = isDataInMese(b.data_invio_preavviso, sel.year, sel.month) ? 0 : 1;
        return aInMese - bInMese;
      });
    });

    onMounted(() => {
      getFornitureInSospensioneSaldate()
    })

    const getFornitureInSospensioneSaldate = () => {
      loader.value = true
      service.getFornitureInSospensioneSaldate(type_fornitura.value)
      .then((res) => {
        items.value = res.items
      })
      .finally(()=>{
        loader.value = false
        self.$eventBus.emit(`dialog-return-ok-button`, {}) 
      }) 
    }

    const onOkButton = () => {
      submitted.value = true;
      loader.value = true

      service.createMultiPreSuspensionOrReactivation(selectedItems.value, type_fornitura.value, 'riattivazioni')
      .then(() => {
        getFornitureInSospensioneSaldate()
      })
      .finally(()=>{
        loader.value = false
        self.$eventBus.emit(`dialog-return-ok-button`, {}) 
      })            
    }
    
    const onCancelButton = () => {
       self.$eventBus.emit(`dialog-return-cancel-button`, {})
    }

    const isRigaBlu = (data) => {
      if (!data || Number(data.saldo) <= 0) {
        return false;
      }
      const oggi = new Date();
      oggi.setHours(0, 0, 0, 0);

      const fatturaNonScaduta = () => {
        if (!data.data_scadenza_fattura) return true;
        const scadenza = new Date(data.data_scadenza_fattura);
        if (isNaN(scadenza.getTime())) return true;
        scadenza.setHours(0, 0, 0, 0);
        return scadenza >= oggi;
      };

      const preavvisoNonScaduto = () => {
        if (!data.data_scadenza_preavviso) return true;
        const scadenza = new Date(data.data_scadenza_preavviso);
        if (isNaN(scadenza.getTime())) return true;
        scadenza.setHours(0, 0, 0, 0);
        return scadenza >= oggi;
      };

      const preavvisoOFatturaNonScaduti = fatturaNonScaduta() || preavvisoNonScaduto();
      if (Number(data.saldoUltimoMese) === 0 && preavvisoOFatturaNonScaduti) return true;
      if (Number(data.saldoUltimoMese) !== 0 && preavvisoNonScaduto()) return true;
      return false;
    };

    const isRigaVerde = (data) => {
      if (!data) return false;
      return Number(data.saldoUltimoMese) === 0 && Number(data.saldo) <= 0;
    };

    const isRigaArancione = (data) => {
      if (!data || Number(data.saldo) !== 0) {
        return false;
      }

      const oggi = new Date();
      oggi.setHours(0, 0, 0, 0);

      const fatturaNonScaduta = () => {
        if (!data.data_scadenza_fattura) return true;
        const scadenza = new Date(data.data_scadenza_fattura);
        if (isNaN(scadenza.getTime())) return true;
        scadenza.setHours(0, 0, 0, 0);
        return scadenza >= oggi;
      };

      const preavvisoNonPartito = !data.data_invio_preavviso;
      return fatturaNonScaduta() || preavvisoNonPartito;
    };

    const rowClass = (data) => {
      if (data && data.volturato_recente) {
        return 'bg-purple-100';
      }
      if (isRigaArancione(data)) {
        return 'bg-orange-100';
      }
      if (isRigaBlu(data)) {
        return 'bg-blue-100';
      }
      if (isRigaVerde(data)) {
        return 'bg-green-100';
      }
      return '';
    };

    return {
      filters,
      page,
      loader,
      items,
      itemsOrdinati,
      selectedItems,
      type_fornitura,
      validationErrors,
      submitted,
      mesePreavvisoSelezionato,
      opzioniMesi,
      onCancelButton,
      onOkButton,
      formatDate,
      rowClass
    }
  }
}


</script>



